
let baseURL = {}
if (process.env.NODE_ENV === 'development') {
  baseURL = {
    reportServer: 'https://qa2-api.at-our.com/atourlife',
    // JAVA_SERVER: window.location.protocol + '//betaa-api.at-our.com/',
    JAVA_SERVER: window.location.protocol + '//qa-api.at-our.com/',
    WXSHARE: 'https://qa0-api.at-our.com/atourlife/miniapp/api/getCommonConfigByWeChat?platType=6&isCorp=false&appVer=2.9.0&channelId=300001&activitySource=&activityId=&paramName=ebf4d1&pageUrl=' + encodeURIComponent(location.href.split('#')[0]),
    finderId: 10000000,
    geetestReceiveCaptchaId: 'ab6218e3ca07d7d9a699bcfcb3d8f0a6',
    geetestGetCodeCaptchaId: '6a91d4e1c81dfa93953125be7d5d6de5',
    system: 'fe-activity-refactoring-qa0',
    wechatUrl: 'https://qa0-wechat.at-our.com/',
    mobileUrl: 'https://qa0-mobile.at-our.com/'
  }
} else if (process.env.NODE_ENV === 'testing') {
  baseURL = {
    reportServer: `https://${process.env.ENV_CONFIG}-api.at-our.com/atourlife`,
    // JAVA_SERVER: window.location.protocol + '//betaa-api.at-our.com/',
    JAVA_SERVER: window.location.protocol + `//${process.env.ENV_CONFIG}-api.at-our.com/`,
    WXSHARE: 'https://qa0-api.at-our.com/atourlife/miniapp/api/getCommonConfigByWeChat?platType=6&isCorp=false&appVer=2.9.0&channelId=300001&activitySource=&activityId=&paramName=ebf4d1&pageUrl=' + encodeURIComponent(location.href.split('#')[0]),
    finderId: 10000000,
    geetestReceiveCaptchaId: 'ab6218e3ca07d7d9a699bcfcb3d8f0a6',
    geetestGetCodeCaptchaId: '6a91d4e1c81dfa93953125be7d5d6de5',
    system: 'fe-activity-refactoring-qa0',
    wechatUrl: 'https://qa0-wechat.at-our.com/',
    mobileUrl: 'https://qa0-mobile.at-our.com/'
  }
} else if (process.env.NODE_ENV === 'pre') {
  baseURL = {
    reportServer: ' https://pre-miniapp.yaduo.com/atourlife',
    JAVA_SERVER: window.location.protocol + '//pre-miniapp.yaduo.com/',
    // JAVA_SERVER: 'http://139.129.233.205:8181/',
    WXSHARE: 'http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=eff45e&isCorp=false&pageUrl=' + encodeURIComponent(location.href.split('#')[0]),
    finderId: 10000000,
    geetestReceiveCaptchaId: 'af86d265150091b0d65e92d290de8c2a',
    geetestGetCodeCaptchaId: '1461c6af6d31942bae54833e928fb5db',
    system: 'fe-activity-refactoring-pre',
    wechatUrl: 'https://pre-wechat.yaduo.com/', // 测试地址
    mobileUrl: 'https://pre-mobile.yaduo.com/'
  }
} else if (process.env.NODE_ENV === 'production') {
  baseURL = {
    reportServer: 'https://miniapp.yaduo.com/atourlife',
    JAVA_SERVER: 'https://api2.yaduo.com/',
    WXSHARE: 'https://miniapp.yaduo.com/atourlife/miniapp/api/getCommonConfigByWeChat?platType=6&appVer=2.9.0&isCorp=false&channelId=300001&activitySource=&activityId=&paramName=ebf4d1&pageUrl=' + encodeURIComponent(location.href.split('#')[0]),
    finderId: 10000003,
    geetestReceiveCaptchaId: 'af86d265150091b0d65e92d290de8c2a',
    geetestGetCodeCaptchaId: '1461c6af6d31942bae54833e928fb5db',
    system: 'fe-activity-refactoring-prod',
    wechatUrl: 'https://wechat.yaduo.com/',
    mobileUrl: 'https://mobile.yaduo.com/'
  }
}
export default baseURL



// WEBPACK FOOTER //
// ./src/config/config.js